import { HeadingSettings } from './types';

export const headingSettings: HeadingSettings = {
  componentVariants: {
    variant: {
      prop: 'variant',
      variants: {
        h1: {
          fontSize: 5,
          fontWeight: 2,
          fontFamily: 'primary',
          lineHeight: 5,
        },
        h2: {
          fontSize: 4,
          fontWeight: 2,
          fontFamily: 'primary',
          lineHeight: 4,
        },
        h3: {
          fontSize: 3,
          fontWeight: 1,
          fontFamily: 'primary',
          lineHeight: 3,
        },
        h4: {
          fontSize: 2,
          fontWeight: 3,
          fontFamily: 'secondary',
          lineHeight: 2,
        },
        h5: {
          fontSize: 1,
          fontWeight: 3,
          fontFamily: 'secondary',
          lineHeight: 1,
        },
        h6: {
          fontSize: 0,
          fontWeight: 3,
          fontFamily: 'secondary',
          lineHeight: 0,
        },
      },
    },
  },
};
